import { Tooltip } from "@material-ui/core";

export type { TooltipProps } from "@material-ui/core";

export default Tooltip;
